import {GetStatesQueryValues, useStatesGetMutation} from "./states-api";
import {useWorkflowIds} from "../../common/OrganizationConfig/useWorkflowIds";

export const useGetStates = () => {
  const {getStatesWorkflowId} = useWorkflowIds();
  const [trigger, result] = useStatesGetMutation();

  const getStates = (queryValues: GetStatesQueryValues) => {
    return trigger({
      workflowId: getStatesWorkflowId,
      values: {
        variables: {
          ...queryValues,
        },
      },
    });
  };

  return [getStates, result] as const;
};
